import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import {
  ClickAwayListener,
  Grow,
  Paper,
  Popper,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import { useQuery } from "@tanstack/react-query";
import React, { useRef, useState } from "react";
import { Fragment } from "react/jsx-runtime";
import { useFormContext, Controller } from "react-hook-form";

import { TagSelectPropInterface } from "./TagSelect";

import { listBrands, cancelPreviousOrderRequest } from "@/api";
import { StyledTypography } from "@/components/ProjectSelect";
import { CreateTaskInterface } from "@/types/task";


export const TagSelect: React.FC<TagSelectPropInterface> = ({ tag }) => {
  const { control } = useFormContext<CreateTaskInterface>();
  const addProductRef = useRef(null);
  const [query, setQuery] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const toggleOpenState = () => setIsOpen(!isOpen);

  const { isLoading: isLoadingTagList, data: tags } = useQuery({
    queryKey: ["list-tags", query],
    queryFn: async () => {
      cancelPreviousOrderRequest();
      return await listBrands({
        query,
        limit: 50,
        offset: 0,
      })
    },
  });

  return (
    <Fragment>
      <Button
        ref={addProductRef}
        endIcon={<ArrowDropDownIcon />}
        onClick={toggleOpenState}
        variant="outlined"
        color="primary"
        startIcon={<LocalOfferIcon />}
        sx={!tag ? { color: "#777" } : {}}
      >
        <StyledTypography>
          {tag || "Add Tag"}
        </StyledTypography>
      </Button>
      <Popper
        open={isOpen}
        anchorEl={addProductRef.current}
        transition
        disablePortal
        placement="bottom-start"
      >
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={() => setIsOpen(false)}>
            <Grow {...TransitionProps} timeout={350}>
              <Paper elevation={5}>
                <Controller
                  control={control}
                  name="tag"
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      options={
                        (tags?.data?.data || [])?.map(({ name }) => name) || []
                      }
                      size="small"
                      onChange={(event, value) => field.onChange(value)}
                      onInputChange={(event, value) => setQuery(value)}
                      sx={{ width: 400 }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Tag"
                          disabled={isLoadingTagList}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <Fragment>
                                {isLoadingTagList ? (
                                  <CircularProgress size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </Fragment>
                            ),
                          }}
                        />
                      )}
                    />
                  )}
                />
              </Paper>
            </Grow>
          </ClickAwayListener>
        )}
      </Popper>
    </Fragment>
  );
};